import { render } from "./AdminTemplateMails.vue?vue&type=template&id=ac39f16e"
import script from "./AdminTemplateMails.vue?vue&type=script&lang=js"
export * from "./AdminTemplateMails.vue?vue&type=script&lang=js"

import "./AdminTemplateMails.vue?vue&type=style&index=0&id=ac39f16e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__